import React, { useEffect, useState } from "react";
import { EyeOutlined, PlusOutlined, DeleteOutlined, CloseOutlined, CheckOutlined, EditOutlined, PlusSquareFilled, ExpandAltOutlined } from '@ant-design/icons';
import { Modal, Col, Row, Table, Button, Form, FormInstance, Select, Input, DatePicker, Space, Spin, Card } from 'antd';
import dayjs from 'dayjs';
import { AlignType } from 'rc-table/lib/interface';

import { SelecionarArquivo } from "../../../components/Documentos/SelecionarArquivo";
import { errorMessage, mostrarInfo, successMessage } from "../../../utils/messages";
import { disabledDate } from "../../../utils/utilsFunctions";
import { getDocPdf } from "../../../services/apiDocumentos";
import { ICertificadoraConsulta, ITipocertificado } from "../../Certificadoras/Componentes/InterfaceCertificadoras";
import { ICertificadoPessoaFisica } from "./InterfacePessoaFisica";
import { IChaves } from "../../../Interfaces/Interfaces";

import { apiCand } from "../../../services/apiCand";
import { hasPermissao, Papel } from "../../../auth/entidadeUsuario";

interface IProps {
  form: FormInstance<any>;
  certificados: ICertificadoPessoaFisica[];
  setCertificados: React.Dispatch<React.SetStateAction<ICertificadoPessoaFisica[]>>;
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar / 9 :  Histórico;
}

const { Option } = Select;
const { TextArea } = Input;

const PessoaFisicaCertificado = ({ form, certificados, setCertificados, manter }: IProps) => {
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const [estadoModal, setEstadoModal] = useState(1); // 1 : Modal em modo inserção / 2 : Modal em modo detalhe /  3 : Modal em modo edição
  const [exibirModalCert, setExibirModalEx] = useState(false);
  const [exibirCertificadoCadastrado, setExibirCertificadoCadastrado] = useState("none");
  const [exibirElementoAcaoAlteracao, setExibirElementoAcaoAlteracao] = useState("inline");
  const [dadosValidados, setDadosValidados] = useState(false);

  const [tipoCertificados, setTipoCertificados] = useState<ITipocertificado[]>([]);
  const [chave, setChave] = useState<number|undefined>();
  const [fileList, setFileList] = useState<IChaves>();


  useEffect(() => {
    if (certificados && certificados.length === 0) {
      setExibirCertificadoCadastrado("none")
    } else {
      setExibirCertificadoCadastrado("inline")
    }
  }, [certificados]);

  useEffect(() => {
    if (chave) {
      setFileList(
        {
          idDocumento: chave,
          ativo: true,
        },
      );

      form.setFieldsValue({
        "idDocumento": chave,
        "chave": chave,
      })
      if (Number(form?.getFieldValue("idPessoaFisicaCertificado")) > 0 && Number(form?.getFieldValue("idDocumento")) === 0) {
        successMessage("O documento será substituído");
      }
    }
  }, [chave]);

  useEffect(() => {
    if (manter === 2 || manter === 9) { // Detalhar / Histórico
      setExibirElementoAcaoAlteracao("none");
    } else {
      setExibirElementoAcaoAlteracao("inline");
    }
  }, [manter]);


  useEffect(() => {
    if (estadoModal === 3) { // EM EDIÇÃO
      controleDaGrid("editar"); // CONFIGURA MODAL PARA ABRIR
    } else if (estadoModal === 2) { // EXIBIR DETALHES
      controleDaGrid("detalhar"); // CONFIGURA MODAL PARA ABRIR
    }
  }, [estadoModal])


  const controleDaGrid = (botao: string) => {
    if (form.getFieldValue("nuCpf") === "") {
      mostrarInfo("Não é possível incluir novo certificado", "CPF ainda não informado");
    } else {
      if (botao === "cancelar") {
        setExibirModalEx(false);
        setExibirElementoAcaoAlteracao("inline");
      } else if (botao === "incluir") {
        setExibirModalEx(false);
        setExibirElementoAcaoAlteracao("inline");
      } else {
        setExibirModalEx(true);
        setExibirElementoAcaoAlteracao("none");
      }
    }

    if (manter === 2 || manter === 9) { // Detalhar / Histórico
      setExibirElementoAcaoAlteracao("none");
    }
  };

  const validarTipoCertificado = () => {
    if (!fileList || !fileList.idDocumento) {
      errorMessage("Selecione um arquivo para 'upload'.");
    } else {
      form
        .validateFields([
          "idPessoaFisicaCertificado",
          "idCertificadora",
          "nmCertificadora",
          "idTpCertificado",
          "nmCertificado",
          "teCodigo",
          "dtEmissao",
          "dtValidade",
          "teObservacao",
        ])
        .then(() => {
          setDadosValidados(true);
          controleDaGrid("incluir");
          setDadosCertificado();
        })
        .catch((error) => {
          if (!dadosValidados) {
            errorMessage("Campo obrigatório não preechido ou não validado");
          } else {
            errorMessage(error.message);
          }
          setDadosValidados(false);
        });
    }
  };

  const setDadosCertificado = () => {
    if (estadoModal === 3) { // ESTADO EDIÇÃO DE REGISTROS
      setCertificados(pre => {
        return pre.map(cert => {
          if (cert.emEdicao) {
            return ({
              idPessoaFisicaCertificado: estadoModal === 3 ? Number(form?.getFieldValue("idPessoaFisicaCertificado")) : -1,
              idTpCertificado: Number(form?.getFieldValue("idTpCertificado")),
              nmCertificado: form?.getFieldValue("nmCertificado")?.toUpperCase(),
              nmCertificadora: form?.getFieldValue("nmCertificadora")?.toUpperCase(),
              teCodigo: form?.getFieldValue("teCodigo"),
              dtEmissao: form?.getFieldValue("dtEmissao") ? dayjs(form?.getFieldValue("dtEmissao")).format("YYYY-MM-DD") : "",
              dtValidade: form?.getFieldValue("dtValidade") ? dayjs(form?.getFieldValue("dtValidade")).format("YYYY-MM-DD") : "",
              teObservacao: form?.getFieldValue("teObservacao")?.toUpperCase(),
              idDocumento: form?.getFieldValue("idDocumento") ? Number(form?.getFieldValue("idDocumento")) : 0,
              documentoChave: fileList,
              statusReg: 1,
              touched: true,
              emEdicao: false,
            })
          } else {
            return cert
          }
        })
      });
    } else {
      setCertificados([
        ...certificados,
        {
          idPessoaFisicaCertificado: estadoModal === 3 ? Number(form?.getFieldValue("idPessoaFisicaCertificado")) : -1,
          idTpCertificado: Number(form?.getFieldValue("idTpCertificado")),
          nmCertificado: form?.getFieldValue("nmCertificado")?.toUpperCase(),
          nmCertificadora: form?.getFieldValue("nmCertificadora")?.toUpperCase(),
          teCodigo: form?.getFieldValue("teCodigo"),
          dtEmissao: form?.getFieldValue("dtEmissao") ? dayjs(form?.getFieldValue("dtEmissao")).format("YYYY-MM-DD") : "",
          dtValidade: form?.getFieldValue("dtValidade") ? dayjs(form?.getFieldValue("dtValidade")).format("YYYY-MM-DD") : "",
          teObservacao: form?.getFieldValue("teObservacao")?.toUpperCase(),
          idDocumento: chave,
          documentoChave: fileList,
          statusReg: 1,
          emEdicao: false,
          touched: true,
        },
      ]);
    }
    limpaDados();
    setEstadoModal(1); // SETA O MODAL PARA INCLUSÃO (MODO PADRÃO).
  }

  const limpaDados = () => {
    form.resetFields([
      "idPessoaFisicaCertificado",
      "idCertificadora",
      "nmCertificadora",
      "idTpCertificado",
      "nmCertificado",
      "teCodigo",
      "dtEmissao",
      "dtValidade",
      "teObservacao",
      "ativo",
    ]);
    setChave(undefined);
  }

  const setFieldsDetalharEditar = (ICertificado: ICertificadoPessoaFisica) => {
    form.setFieldsValue({
      "idPessoaFisicaCertificado": ICertificado.idPessoaFisicaCertificado ? ICertificado.idPessoaFisicaCertificado : -1,
      "idTpCertificado": ICertificado.idTpCertificado,
      "nmCertificado": ICertificado.nmCertificado,
      "idCertificadora": ICertificado.idCertificadora,
      "nmCertificadora": ICertificado.nmCertificadora,
      "teCodigo": ICertificado.teCodigo,
      "dtEmissao": ICertificado.dtEmissao ? dayjs(ICertificado.dtEmissao) : undefined,
      "dtValidade": ICertificado.dtValidade ? dayjs(ICertificado.dtValidade) : undefined,
      "teObservacao": ICertificado.teObservacao,
      "chave": ICertificado.idDocumento,
      "idDocumento": ICertificado.idDocumento
    });
    setChave(ICertificado.idDocumento);
  }

  const columns = [
    {
      // width: 200,
      key: "1",
      title: "Nome",
      dataIndex: "",
      render: (ICertificado: ICertificadoPessoaFisica) => <>{ICertificado.nmCertificado}</>,
    },
    {
      // width: 200,
      key: "2",
      title: "Data Emissão",
      dataIndex: "",
      render: (ICertificado: ICertificadoPessoaFisica) => <>{dayjs(ICertificado.dtEmissao).format("DD/MM/YYYY")}</>,
    },
    {
      // width: 200,
      key: "3",
      title: "Data Validade",
      dataIndex: "",
      render: (ICertificado: ICertificadoPessoaFisica) => <>{ICertificado.dtValidade ? dayjs(ICertificado.dtValidade).format("DD/MM/YYYY") : undefined}</>,
    },
    {
      key: "111", // PARA ARQUIVOS JÁ SALVOS NA TABELA DE DOCUMENTOS ARQUIVOS
      title: "Arquivo",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (ICertificado: ICertificadoPessoaFisica) => (
        <div style={{ display: ICertificado.idDocumento ? "inline" : "none" }}>
          <Button
            id="arquivo"
            shape="round"
            icon={<EyeOutlined />}
            htmlType="button"
            onClick={() => {
                getDocPdf(ICertificado.idDocumento!);
            }}
          />
        </div>
      ),
    },
    {
      key: "9",
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (ICertificado: ICertificadoPessoaFisica) => (
          <Space style={{justifyContent: 'center'}}>
            <div style={{ display: manter === 2 || manter === 9 ? "inline" : "none" }}>
              <ExpandAltOutlined
                title="Detalhar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  setEstadoModal(2); // SET O MODO DETALHAR
                  setFieldsDetalharEditar(ICertificado);
                }}
              />
            </div>

            <div style={{ display: manter === 1 ? "inline" : exibirElementoAcaoAlteracao }}>
              <EditOutlined
                title="Editar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  setEstadoModal(3); // SET O MODO EDIÇÃO
                  setFieldsDetalharEditar(ICertificado);
                  // ALTERA CAMPOS DO DATASET PARA REFLETIR O ESTADO DE EDIÇÃO
                  certificados.forEach(cert => {
                    if (cert === ICertificado) {
                      cert.statusReg = 1;
                      cert.touched = true;
                      cert.emEdicao = estadoModal === 3 ? true : false;
                    } else {
                      cert.emEdicao = false;
                    }
                  })
                  ICertificado.emEdicao = true;
                }}
              />

              <DeleteOutlined
                title="Exluir"
                style={{ color: "red", display: (ICertificado?.idPessoaFisicaCertificado && ICertificado?.idPessoaFisicaCertificado < 0) ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
                onClick={() => {
                  setCertificados(certificados.filter((certificado) => certificado !== ICertificado));
                }}
              />
            </div>

            <div style={{ display: (ICertificado?.idPessoaFisicaCertificado && ICertificado?.idPessoaFisicaCertificado > 0) && hasPermissao([Papel.DILIC_MASTER]) ? exibirElementoAcaoAlteracao : "none" }}>
              <>
                <PlusSquareFilled
                  title="Desmarcar para exclução/inativação"
                  style={{ color: "blue", display: (ICertificado?.statusReg === 1 || ICertificado?.statusReg === undefined) ? "none" : "inline" }}
                  onClick={() => {
                    ICertificado.touched = true; // MARCA O REGISTRO ALTERADO.
                    ICertificado.statusReg = (ICertificado.statusReg === 1 ? 2 : 1);
                    setCertificados(pre => { //TROCA O REGISTRO DO DATASET PELO REGISTRO EM ALTERAÇÃO
                      return pre.map(certificado => {
                        if (certificado.idPessoaFisicaCertificado === ICertificado.idPessoaFisicaCertificado) {
                          return ICertificado;
                        } else {
                          return certificado;
                        }
                      });
                    });
                  }}
                />
                <DeleteOutlined
                  title="Marcar para exclução/inativação"
                  style={{ color: "red", display: (ICertificado?.statusReg === 1 || ICertificado?.statusReg === undefined) ? "inline" : "none" }}
                  onClick={() => {
                    ICertificado.touched = true; // MARCA O REGISTRO ALTERADO.
                    ICertificado.statusReg = (ICertificado.statusReg === 1 ? 2 : 1);
                    setCertificados(pre => {
                      return pre.map(certificado => {
                        if (certificado.idPessoaFisicaCertificado === ICertificado.idPessoaFisicaCertificado) {
                          return ICertificado;
                        } else {
                          return certificado;
                        }
                      });
                    });
                  }}
                />
              </>
            </div>
          </Space>
      ),
    },
  ];


  const handleCancel = () => {
    setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO. MODO PADRÃO
    controleDaGrid("cancelar");
    form.resetFields([
      "idTpCertificado",
      "nmCertificado",
      "teCodigo",
      "dtReconhecimentoCertificado",
      "teDetalhamento",
      "dtCancelamento",
      "ativo",
    ]);
  };


  useEffect(() => {
    if (certificadoras.length === 0) getCertificadora();
  }, [])

  const [certificadoras, setCertificadoras] = useState<ICertificadoraConsulta[]>([]);
  const getCertificadora = async () => {
    let lQuery = `certificadoras?cancelada=false`;
    const { data } = await apiCand.get(lQuery);
    setCertificadoras(data.content);
  }

  const handlerCertificadora = async (value: any) => {
    form.setFieldsValue({
      "nmCertificadora": value.children,
      "idCertificadora": value.key,
    });
    getTipoCertificado(Number(value.key));
  };

  const getTipoCertificado = async (idCertificadora: number) => {
    setTipLoading("Buscando certificados ...");
    setLoading(true);
    let lQuery = `certificadoras/${idCertificadora}/tipocertificado`;
    const { data } = await apiCand.get(lQuery);
    setTipoCertificados(data);
    setLoading(false);
  }

  const handlerTipoCertificado = async (value: any) => {
    form.setFieldsValue({
      "nmCertificado": value.children,
      "idTpCertificado": value.key,
    });
  };

  return (
    <>
      <Button
        style={{ display: exibirElementoAcaoAlteracao }}
        id="incluirTipoCertificado"
        type="primary"
        shape="round"
        onClick={() => {
          limpaDados();
          setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO.
          controleDaGrid("incluirTipoCertificado");
        }}
        icon={<PlusOutlined />}
      >
        Incluir Certificado
      </Button>

      <>
        <Modal title="Certificado" open={exibirModalCert}
          style={{ top: 20 }}
          destroyOnHidden={true}
          width={700}
          closable={false}
          footer={[
            <Button icon={<CloseOutlined />} shape="round" key="cancelFechar" onClick={handleCancel}>
              {estadoModal === 2 ? "Fechar" : "Cancelar"}
            </Button>,
            <Button icon={<CheckOutlined />} shape="round" style={{ display: estadoModal === 2 ? "none" : "inline" }}
              key="ok" type="primary" onClick={validarTipoCertificado}>
              {estadoModal === 3 ? "Alterar" : "Incluir"}
            </Button>,
          ]}
        >
          <Spin spinning={loading} tip={tipLoading}>
            <>
              <Row>
                <Col xs={24} sm={24}>
                  <Form.Item label='Certificadora'
                    name='nmCertificadora'
                    labelCol={{ span: 12 }}
                    labelAlign="left"
                    colon={false}
                  >
                    <Select
                      style={{ width: 600 }}
                      showSearch
                      filterOption
                      optionFilterProp='children'
                      placeholder='Certificadora'
                      disabled={estadoModal === 2}
                      onChange={(_, index) => {
                        handlerCertificadora(index);
                      }}
                    >
                      {certificadoras?.map((e: any) => (
                        <Option key={e.idCertificadora} value={e.idCertificadora}>
                          {e.razaoSocial}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col xs={24} sm={24}>
                  <Form.Item label='Certificado'
                    name='nmCertificado'
                    labelCol={{ span: 12 }}
                    labelAlign="left"
                    colon={false}
                  >
                    <Select
                      style={{ width: 600 }}
                      showSearch
                      filterOption
                      optionFilterProp='children'
                      placeholder='Certificado'
                      disabled={estadoModal === 2}
                      onChange={(_, index) => {
                        handlerTipoCertificado(index);
                      }}
                    >
                      {tipoCertificados?.map((e: any) => (
                        <Option key={e.idTpCertificado} value={e.idTpCertificado}>
                          {e.nmCertificado}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col xs={24} sm={8}>
                  <Form.Item label='Código'
                    name='teCodigo'
                    colon={false}
                  >
                    <Input
                      disabled={estadoModal === 2}
                      maxLength={20}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8}>
                  <Form.Item label="Data de Emissão"
                    name="dtEmissao"
                    colon={false}
                    rules={[
                      {
                        required: true,
                        message: "Data de emissão obrigatória",
                      },
                    ]}
                  >
                    <DatePicker
                      format={"DD/MM/YYYY"}
                      style={{ width: "100%" }}
                      placeholder="Selecionar Data"
                      disabled={estadoModal === 2}
                      disabledDate={disabledDate}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8}>
                  <Form.Item label="Data de Validade"
                    name="dtValidade"
                    colon={false}
                    rules={[
                      {
                        required: true,
                        message: "Data de validade obrigatória",
                      },
                      {
                        validator: async (_, endDatetime) => {
                          let startDatetime = form.getFieldValue("dtEmissao");
                          if (startDatetime) {
                            if (endDatetime <= startDatetime) {
                              return Promise.reject(
                                "Data de validade deve ser maior do que a data de emissão"
                              );
                            }
                          }
                        },
                      },
                    ]}
                  >
                    <DatePicker
                      format={"DD/MM/YYYY"}
                      style={{ width: "100%" }}
                      placeholder="Selecionar Data"
                      disabled={estadoModal === 2}
                    />
                  </Form.Item>
                </Col>

              </Row>

              <Row>
                <Card title="Arquivo" variant="borderless" style={{ width: "100%" }}>
                  <Row justify="space-between">
                    <Col xs={24} sm={12} style={{ display: estadoModal === 2 ? 'none' : 'inline' }}>
                      <SelecionarArquivo
                        setChave={setChave}
                        identificador={true}
                        label=""
                      />
                    </Col>
                    
                    <Col xs={24} sm={12} style={{ display: estadoModal === 1 ? 'none' : 'inline' }}>
                      <Button
                        id="arquivo"
                        title="Arquivo"
                        shape="round"
                        icon={<EyeOutlined />}
                        htmlType="button"
                        onClick={() => {
                          if (form?.getFieldValue("idPessoaFisicaCertificado") && form?.getFieldValue("idPessoaFisicaCertificado") < 0) { // NOVO REGISTRO 
                              getDocPdf(form?.getFieldValue("chave"));
                          } else if (form?.getFieldValue("idPessoaFisicaCertificado") && form?.getFieldValue("idPessoaFisicaCertificado") > 0) { // REGISTRO JÁ SALVO NA BASE
                              getDocPdf(form?.getFieldValue("idDocumento"));
                          }
                        }}
                      />
                    </Col>
                  </Row>
                </Card>
              </Row>

              <Row>
                <Col xs={24} sm={24}>
                  <Form.Item label='Observação'
                    labelCol={{ span: 24 }}
                    name='teObservacao'
                  >
                    <TextArea rows={4}
                      placeholder='Observação'
                      disabled={estadoModal === 2}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </>
          </Spin>
        </Modal>

      </>

      <Row style={{ display: exibirCertificadoCadastrado }}>
        <Col
          xs={24}
          xl={24}
          style={{ paddingLeft: 16, paddingRight: 16, marginBottom: 20 }}
        >
          <Table size="small" showHeader={true} columns={columns} dataSource={certificados} pagination={false} />
        </Col>
      </Row>

    </>
  )
};

export default PessoaFisicaCertificado;